<template>
    <div class="package-container">
		
		<div class="top-promotion" v-if="isShowPromotionTag">
			<div class="left-promotion flex a-i-c">
				<div class="promotion-tag flex-center t-c origin" v-if="itemData.promotion&&itemData.promotion.title">特價</div>
				<div class="promotion-tag flex-center t-c blue" v-else-if="itemData.type==0">普通商品</div>
				<div class="promotion-tag flex-center t-c red" v-else-if="itemData.type==1">包裹</div>
				<span v-if="itemData.promotion">
					{{itemData.promotion.title }}
				</span>
			</div>
			<div class="right-addbuy">
			</div>
		</div>

        <div class="goods-wrap">
            <div class="goods-cover" v-if="itemData.spuCover">
                <img :lazyLoad="true"  mode="aspectFit" type="custom" :src="itemData.spuCover" class="order-detail-cover" />
            </div>
            <div class="sku-info pt-5" style="min-height: 40px;">
                <div class="pack-content" v-if="itemData.type==1">
                    <div class="spu-title flex a-i-c">
                        <div class="strong flex a-i-c">
                            <div>
                                <span v-if="itemData.extraJson&&getEcPackName(itemData.extraJson)">{{getEcPackName(itemData.extraJson)}}</span>
                                <span v-else>{{itemData.spuName?itemData.spuName:''}}</span>
                            </div>
                            
                            <!-- <div class="refund-box" v-if="itemData.status&&itemData.status=='untake'">
                                未取貨
                            </div> -->
                            <!-- <div class="refund-tag" v-if="detail&&itemData.refundQuantity>=1">
                                <span v-if="detail&&detail.payTime">缺貨x{{itemData.refundQuantity}} 已退款</span>
                                <span v-if="detail&&!detail.payTime">交易取消</span>
                            </div> -->
                            
                        </div>
                        <div >NT$ {{itemData.unitPrice?itemData.unitPrice:0}}</div>
                    </div>
                    <div class="sku-item" v-if="manageCode">
                        {{manageCode}}
                    </div>

					<div class="spu-count-refund">
						<div class="quantity-content">
							<div class="count">x {{itemData.quantity?itemData.quantity:0}}</div>
						</div>
					</div>

                </div>
                <div class="spu-content" v-else>
                    <div class="spu-title">
                        <span class="strong">{{itemData.spuName?itemData.spuName:''}}</span>
                        <span class="spu-title-price">NT$ {{itemData.unitPrice?itemData.unitPrice:""}}</span>
                    </div>
                    <div class="sku-item justify-between" >
                        <span class="strong">{{itemData.propertyValues?itemData.propertyValues:''}}</span>
                    </div>
                    <div class="spu-count-refund">
                        <div class="quantity-content">
                            <div class="count">x {{itemData.quantity?itemData.quantity:""}}</div>
                            <!-- <div class="refund-tag" v-if="itemData.refundQuantity>=1">
                                <span v-if="detail&&detail.payTime">缺貨x{{itemData.refundQuantity}} 已退款</span>
                                <span v-if="detail&&!detail.payTime">交易取消</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import BaseItem from "jbang-uni/ui/components/base-item/base-item.vue";
    export default {
        // extends:BaseItem,
        data() {
            return {
                
            }
        },
        props:{
            itemData:{
                type:Object,
                default:{}
            },
            detail:{
                type:Object,
                default:{}
            },
			isShowPromotionTag:{
				type:Boolean,
				default:false
			}
            
        },
        computed:{
        	manageCode(){
        		if(this.itemData.extraJson){
        			let extraJson = JSON.parse(this.itemData.extraJson);
        			return extraJson.manageCode
        		}
        		return "";
        	},
        },
		filters:{
			promotionTitle(val){
				if(!val)return "";
				try{
					let json = JSON.parse(val);
					return json[0]&&json[0].promotionTree&&json[0].promotionTree.promotion.title?json[0].promotionTree.promotion.title:""
				}catch{
					return "";
				}
			}
		},
        onLoad() {
        },
        methods:{
            getEcPackName(extraJson){
            	try{
            		let extra = JSON.parse(extraJson);
            		if(extra&&extra.channelId&&extra.channelId&&extra.channelId=="EC"){
            			return extra.businessName;
            		}
            	}catch(err){}
            	return "";
            }
        }
    }
</script>
<style lang='less' scoped>

	.package-container{
		margin-top: 15px;
	}

	.goods-wrap{
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-width: 250px;
	}
	.goods-cover{
		border-radius: 6px;
		height: 68px;
		width: 86px;
		overflow: hidden;
		.order-confirm-cover{
			width: 65px;
			height: 65px;
			border-radius: 6px;
		}
		.order-detail-cover{
			width: 58px;
			height: 58px;
			border-radius: 6px;
			object-fit: contain;
		}
	}

	.refund-tag {
		display: inline-block;
		font-size: 11px;
		margin-left: 10px;
		border-radius: 15px;
		background-color: #fff;
		padding: 3px 5px;
		color: #f63c2c;
		border: 0.5px solid #f63c2c;
		margin-top: 5px;
		span{
			color: #f63c2c !important;
			font-size: 11px !important;
		}
	}

	.sku-info{
		min-width: 150px;
		width: 100%;
		margin-left: 10px;
		min-height: 80px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 5px;

		.pack-content{
			min-height: 50px;
			padding-bottom: 10px;
		}

		.spu-title{
			color: #333;
			font-size: 14px;
			display: flex;
			justify-content: space-between;
			width: 100%;
			span:nth-child(1){
				color: #333;
				font-size: 14px;
				flex: 1;
				display: -webkit-box;
				overflow: hidden;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
			}
		}
		.spu-title-price{
			margin-left: 3px;
			font-weight: bold;
			color: #909090;
			font-size: 14px;
		}
		.sku-item{
			color: #888B94;
			margin: 5px 0 10px 0;
			font-size: 12px;
		}
		.spu-count-refund{
			display: flex;
			align-items: center;
			margin-top: 5px;
			.count{
				font-size: 14px;
				color: #888B94;
			}
			.refund-box{
				font-size: 11px;
				margin-left: 10px;
				border-radius: 15px;
				background-color: #fff;
				padding: 3px 5px;
				color: #F63C2C;
				border: 1px solid #F63C2C;
			}
            .quantity-content{
            		display: flex;
            		align-items: center;
            	.count{
            		font-size: 14px;
            		color: #888B94;
            	}
            }
            .promotion-price{
            	color: #909090;
            	font-weight: bold;
            	font-size: 16px;
            }
            .label{
            	color: #333333;
            	font-weight: bold;
            }
		}
		.spu-price-count{
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			div{
				font-size: 14px;
				color: #888B94;
			}
			.price{
				font-weight: bold;
				color: #333333;
			}
			.empty-quantity-tips{
				font-size: 12px;
				color: #FF7511;
				margin-right: 5px;
				font-weight: bold;
			}
			.count-step{
				display: flex;
				align-items: center;
			}
			.cart-box{
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 25px;
				.change-btn{
					width: 28px;
					height: 100%;
					border: 1px solid #C2C6C8;
					display: flex;
					justify-content: center;
					align-items: center;
					box-sizing: border-box;
				}
				.sub-btn{
					border-top-left-radius: 15px;
					border-bottom-left-radius: 15px;
				}
				.add-btn{
					border-top-right-radius: 15px;
					border-bottom-right-radius: 15px;
				}
				input{
					display: flex;
					box-sizing: border-box;
					justify-content: center;
					align-items: center;
					width: 30px;
					color: #333333;
					height: 100%;
					text-align: center;
					border: 1px solid #C2C6C8;
				}
				.btn-color-gray{
					color: #C2C6C8;
				}
				.btn-color-light{
					color: #333333;
				}
			}
		}
	}

	    .top-promotion{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px 12px 10px 0;
			.left-promotion{
				display: flex;
				font-size: 12px;
				color: #6F6F6F;
				align-items: center;
				.promotion-tag{
					border-radius: 4px;
					border: 1px solid #323233;
					color: #323233;
					font-size: 12px;
					padding: 2px 8px;
					margin-right: 5px;
					white-space: nowrap;
					min-width: 50px;
					&.red{
						border: 1px solid #52c41a;
						color: #52c41a;
					}
					&.blue{
						border: 1px solid #C9C9C9;
						background-color: #F5F5F5;
						color: #4B4B4B;
					}
					&.origin{
						border: 1px solid #FFD3B2;
						color: #EF6500;
						background-color: #FFF3EB !important;
					}
				}
			}
			.right-addbuy{
				display: flex;
				align-items: center;
				image{
					width: 6px;
					height: 12px;
					padding-left: 5px;
				}
			}
		}
		.flex-center{
			display: flex;
			align-items: center;
			justify-content: center;
		}
	
</style>